import React from "react";
import { useParams } from "react-router-dom";
import { useEmailMarketingCampaignRecipientVariablesQuery } from "__generated__/graphqlUnauthenticated";
import { getPrimaryEmail } from "./getPrimaryEmail";
import { EmailMarketingUnsubscribePageUI } from "./EmailMarketingUnsubscribePageUI";

export const EmailMarketingUnsubscribePage: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const { data, loading } = useEmailMarketingCampaignRecipientVariablesQuery({
    variables: {
      emsUserToken: token || "",
    },
    skip: !token,
  });

  const primaryEmail = getPrimaryEmail(
    data?.emailMarketingCampaignRecipientVariables?.entries || [],
  );

  return (
    <EmailMarketingUnsubscribePageUI
      loading={loading}
      primaryEmail={primaryEmail}
      emsUserToken={token || ""}
    />
  );
};
